import * as React from 'react'

import {
  type MessageSeriesPosition,
  getMessageSeriesBubbleClassName,
  getMessageSeriesBubblePaddingClassName,
  getSplitAttachmentSeriesPosition,
  getSplitTextSeriesPosition,
} from '@/utils/chat-message-series'

interface MessageAttachmentTextSplitProps {
  isOwnMessage: boolean
  seriesPosition: MessageSeriesPosition
  attachment: React.ReactNode
  text: React.ReactNode
  textBubbleClassName: string
  extras?: React.ReactNode
}

export const MessageAttachmentTextSplit: React.FC<MessageAttachmentTextSplitProps> = ({
  isOwnMessage,
  seriesPosition,
  attachment,
  text,
  textBubbleClassName,
  extras,
}) => {
  const attachmentPosition = getSplitAttachmentSeriesPosition(seriesPosition)
  const textPosition = getSplitTextSeriesPosition(seriesPosition)
  const attachmentSeriesClassName = getMessageSeriesBubbleClassName(attachmentPosition, isOwnMessage)
  const textSeriesClassName = getMessageSeriesBubbleClassName(textPosition, isOwnMessage)
  const attachmentPaddingClassName = getMessageSeriesBubblePaddingClassName(attachmentPosition)
  const textPaddingClassName = getMessageSeriesBubblePaddingClassName(textPosition)

  const attachmentShellClassName = `relative inline-flex max-w-full min-w-0 flex-col overflow-hidden ${attachmentSeriesClassName} ${attachmentPaddingClassName}`

  const textShellClassName = `relative inline-flex max-w-full min-w-0 flex-col overflow-hidden px-3.5 py-2 text-sm shadow-sm transition-all duration-200 hover:shadow-md ${textSeriesClassName} ${textPaddingClassName} ${textBubbleClassName}`

  return (
    <div className={`flex w-full min-w-0 flex-col gap-1 ${isOwnMessage ? 'items-end' : 'items-start'}`}>
      <div className={attachmentShellClassName}>{attachment}</div>
      <div className={textShellClassName}>
        {text}
        {extras}
      </div>
    </div>
  )
}
